import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getInitials(name: string = ''): string {
  if (!name || typeof name !== 'string') {
    return '';
  }
  const words = name.trim().split(/\s+/);
  if (words.length === 0 || words[0] === '') {
    return '';
  }
  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }
  return (words[0][0] + (words[words.length - 1][0] || '')).toUpperCase();
}